/*
 * Copyright © 2015-2022 Serenova, LLC. All rights reserved.
 */

/*
 * urlParamsToObj
 *
 * Returns an object with the parsed current url queryParams
 *
 */
export function urlParamsToObj() {
  const queryParamsObj = {};
  const url = window.location.search ? window.location.search : window.location.hash;
  if (url.indexOf('login') > 0) {
    const queryParamsArr = url.replace('#/login?', '').split(/[&#]+/);
    queryParamsArr.forEach((queryParamsItem) => {
      if (queryParamsItem !== '') {
        const splitQueryParams = queryParamsItem.toLowerCase().split('=');
        queryParamsObj[splitQueryParams[0]] = splitQueryParams[1] || 1;
      }
    });
  } else {
    const queryParamsArr = url.substring(1).split(/[&#]+/);
    queryParamsArr.forEach((queryParamsItem) => {
      if (queryParamsItem !== '') {
        const splitQueryParams = queryParamsItem.toLowerCase().split('=');
        queryParamsObj[splitQueryParams[0]] = splitQueryParams[1] || 1;
      }
    });
  }
  return queryParamsObj;
}

/*
 * removeAuthParams
 *
 * Removes query params used for deep linking
 *
 */
export function removeAuthParams() {
  const QUERY_PARAMS = [
    'username',
    'tenantid',
    'idp',
    'tenantididp',
  ];
    const queryParamsArr = window.location.search.substring(1).split(/[?&#]+/);
    // remove any key/val pairs in the queryParams where the key is
    // designated as a deep link query parameter
    const updatedQueryParams = queryParamsArr
      .filter((queryParamsItem) => {
        const splitQueryParams =
          queryParamsItem && queryParamsItem.toLowerCase().split('=');
        return QUERY_PARAMS.indexOf(splitQueryParams[0]) === -1;
      })
      .join('&');
  
    // update the URL in the address bar, making sure to keep
    // the hash in place if there is one
    window.history.pushState(
      '',
      document.title,
      `${window.location.pathname}?${updatedQueryParams}${window.location.hash}`
    );
  }

/*
 * msOauthParamsToObj
 *
 * Returns an object with the parsed Microsoft OAuth parameters
 *
 */
export function msOauthParamsToObj() {
  const msParamsObj = {};
  const url = window.location.search ? window.location.search : window.location.hash;
  if (url.indexOf('code') > 0 || url.indexOf('error') > 0) {
    const queryParamsArr = new URLSearchParams(url);
    for (const [key, value] of queryParamsArr) {
      msParamsObj[key] = value;
    }
  }
  return msParamsObj;
}